import { PlanAdd } from './PlanAdd';

export default PlanAdd;